module.exports = __webpack_public_path__ + "static/media/iconWhatsApp.1f952c57.svg";